import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {environment} from '@environments/environment';
import {Result} from "@domain/common/http/result";
import {first,map} from "rxjs/operators";
import {CompteApi} from "@domain/admin/parametre/api/compte-api";

/**
 * Service de gestion des comptes API REST
 */
@Injectable()
export class ApiRestService {

	/**
	 * Constructeur
	 *
	 * @param http Service HTTP
	 */
	constructor(private http: HttpClient) {}

    /**
     * Suppression d'un compte API
     *
     * @param idCompte ID du compte à supprimer
     */
    deleteCompteApi(idCompte: number): Observable<Result> {
        return this.http.post<Result>(`${environment.baseUrl}/controller/CompteAPI/deleteCompteApi/${idCompte}`,null).pipe(first());
    }

    /**
     * Sauvegarde d'un compte API
     *
     * @param compteApi compte à sauvegarder
     */
    saveCompteApi(compteApi: CompteApi): Observable<Result> {
        return this.http.put<Result>(`${environment.baseUrl}/controller/CompteAPI/saveCompteApi`,compteApi).pipe(first());
    }

    /**
     * Chargement d'un compte API
     *
     * @param idCompte ID du compte à charger
     */
    loadCompteApi(idCompte: number): Observable<Result> {
        return this.http.post<Result>(`${environment.baseUrl}/controller/CompteAPI/loadCompteApi/${idCompte}`,null).pipe(first());
    }

    /**
     * Générer une nouvelle clé pour le compte
     *
     * @param idCompte ID du compte concerné
     */
    generateNewKey(idCompte: number): Observable<Result> {
        return this.http.post<Result>(`${environment.baseUrl}/controller/CompteAPI/generateNewKey/${idCompte}`,null).pipe(first());
    }

    /**
     * Déverrouiller un compte API
     *
     * @param idCompte ID du compte concerné
     */
    unlockCompteApi(idCompte: number): Observable<Result> {
        return this.http.post<Result>(`${environment.baseUrl}/controller/CompteAPI/unlockCompteApi/${idCompte}`,null).pipe(first());
    }

	/**
	 * Chargement des informations sur l'API
	 *
	 * @return Les endpoints et les méthodes HTTP accessibles
	 */
	loadApiInformation(): Observable<ApiInformation> {
		return this.http.post<Result>(`${environment.baseUrl}/controller/CompteAPI/loadApiInformation`,null)
			.pipe(map(result => result.data as ApiInformation));
	}
}

/**
 * Interface représentant les informations sur l'API
 */
export interface ApiInformation {
	//Map des endpoints disponibles (path -> libellé)
	mapAPI: {[key: string]: string};

	//Liste des méthodes HTTP disponibles
	listeHttpMethods: string[];
}